(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("refund", {
            parent: "app",
            url: "/refund?page?status?date",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/refund/refund.html",
                    controller: "RefundController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
